import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { deleteDerivacionCandidatoRelacion } from "../../services/derivacionServices";
import { ButtonPrimary } from "../../ui/buttons";

const DeleteCandidatoModal = ({ toggle, isOpen, info, derivacionId, setReloadCandidatos, deleteCandidatoDerivado }) => {
  const handleDeleteCandidato = () => {
    deleteDerivacionCandidatoRelacion(derivacionId, info.id);
    const editData = {
      derivacionId,
    };
    deleteCandidatoDerivado(editData);
    setReloadCandidatos(true);
    toggle();
  };
  return (
    <div>
      <Modal isOpen={isOpen} centered style={{ fontFamily: "Nunito" }}>
        <ModalHeader className="border-0 height-50" toggle={toggle} />
        <ModalBody>
          <FontAwesomeIcon icon={faWarning} className="mr-4 w-100" color="#F0292A" size="4x" />
          <p className="badge-pills h-50 w-100 justify-content-center text-justify p-2" style={{ fontSize: "16px", fontWeight: "normal", padding: "10px 0" }}>
            ¿Esta seguro de eliminar el candidato de la derivación?
          </p>
        </ModalBody>
        <ModalFooter className="border-0 height-50">
          <div className=" mt-3 mb-0 d-flex justify-content-end">
            <Button color="btn-secondary mr-2" onClick={toggle}>
              No
            </Button>
            <ButtonPrimary type="button" style={{ width: "80px", justifyContent: "center" }} fontSize="14px" onClick={handleDeleteCandidato}>
              Si
            </ButtonPrimary>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DeleteCandidatoModal;
